import Paper from '@mui/material/Paper';
import {Box, Tab, Tabs} from '@mui/material';
import React, {useState} from 'react';
import {CreditRequestController} from '../../api/credit/credit-request.controller';
import {Pagination} from '../../components/Pagination';
import {StatusCallsPage} from '../status-calls/StatusCallsPage';
import {CreditRequestAttachmentDrawer} from './components/CreditRequestAttachmentDrawer';
import {CreditRequestDrawer} from './components/CreditRequestDrawer';
import {CreditRequestFilterBar} from './components/CreditRequestFilterBar';
import {CreditRequestGroupedView} from './components/CreditRequestGroupedView';
import {useCreditSupportPageState} from './state/credit-support-page-state';

type CreditSupportTab = 'tickets' | 'status-calls';

export const CreditSupportPage = () => {
  const state = useCreditSupportPageState()
  const [tab, setTab] = useState<CreditSupportTab>('tickets')

  return <Paper sx={{height: '100%', width: '100%', padding: 2, position: 'relative'}}>
    <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{mb: 2}}>
      <Tab value="tickets" label={state.translateLocal('tab.tickets')}/>
      <Tab value="status-calls" label={state.translateLocal('tab.statusCalls')}/>
    </Tabs>

    {tab === 'tickets' ? (
      <Box>
        <CreditRequestFilterBar
          translate={state.translate}
          translateLocal={state.translateLocal}
          searchableState={state.searchableState}
          searchText={state.searchableState.fullTextSearch}
          onSearchText={state.searchableState.onFullTextSearch}
          extractAvailableValues={state.extractAvailableValues}
        />
        <CreditRequestGroupedView
          requests={state.requests}
          onRequestPressed={(request) => {
            state.setSelectedRequest(request)
            state.setDrawerOpen(true)
          }}
          onAttachmentPressed={(request) => {
            state.setSelectedRequest(request)
            state.setAttachmentDrawerOpen(true)
          }}
          onReorder={async (orderedIds) => {
            try {
              await CreditRequestController.reorderCreditRequests(orderedIds)
              state.refreshRequests()
            } catch (e) {
              console.error('Failed to reorder backlog', e)
            }
          }}
          translateLocal={state.translateLocal}
          translate={state.translate}
        />
        <Pagination
          count={state.total}
          page={state.searchableState.searchable.page - 1}
          rowsPerPage={state.searchableState.searchable.pageSize}
          onPageChange={(page) => state.searchableState.onPage(page + 1)}
          onRowsPerPageChange={state.searchableState.onPageSize}
        />
        {
          state.selectedRequest === null
            ? <></>
            : <CreditRequestDrawer
              request={state.selectedRequest}
              isDrawerOpen={state.isDrawerOpen}
              refreshRequests={state.refreshRequests}
              translate={state.translate}
              translateLocal={state.translateLocal}
              onDrawerClosed={() => {
                state.setDrawerOpen(false)
                state.setSelectedRequest(null)
              }}
            />
        }
        {
          state.selectedRequest === null || !state.isAttachmentDrawerOpen
            ? <></>
            : <CreditRequestAttachmentDrawer
              isDrawerOpen={state.isAttachmentDrawerOpen}
              request={state.selectedRequest}
              translate={state.translate}
              onDrawerClosed={() => {
                state.setAttachmentDrawerOpen(false)
                state.setSelectedRequest(null)
              }}
            />
        }
      </Box>
    ) : (
      <StatusCallsPage/>
    )}
  </Paper>
}
